export const latest = [
    {
        "Poster": "https://m.media-amazon.com/images/M/MV5BMTc5MDE2ODcwNV5BMl5BanBnXkFtZTgwMzI2NzQ2NzM@._V1_SX300.jpg",
        "Title": "Avengers:Endgame",
        "Year": "2019",
        "imdbID": "tt4154796"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BMTE0YWFmOTMtYTU2ZS00ZTIxLWE3OTEtYTNiYzBkZjViZThiXkEyXkFqcGdeQXVyODMzMzQ4OTI@._V1_SX300.jpg",
        "Title": "Captain Marvel",
        "Year": "2019",
        "imdbID": "tt4154664"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BNTczMzc4NDY0MF5BMl5BanBnXkFtZTgwMjI3Njg3NjM@._V1_SX300.jpg",
        "Title": "The Intruder",
        "Year": "2019",
        "imdbID": "tt6722030"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BMTYxNjE2NjIwOF5BMl5BanBnXkFtZTgwMjE0MzkxNzM@._V1_SX300.jpg",
        "Title": "What Men What",
        "Year": "2019",
        "imdbID": "tt7634968"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BMGZlNTY1ZWUtYTMzNC00ZjUyLWE0MjQtMTMxN2E3ODYxMWVmXkEyXkFqcGdeQXVyMDM2NDM2MQ@@._V1_SX300.jpg",
        "Title": "Spider-Man: Far from Home",
        "Year": "2019",
        "imdbID": "tt6320628"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BYTE0Yjc1NzUtMjFjMC00Y2I3LTg3NGYtNGRlMGJhYThjMTJmXkEyXkFqcGdeQXVyNTI4MzE4MDU@._V1_SX300.jpg",
        "Title": "Shazam!",
        "Year": "2019",
        "imdbID": "tt0448115"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BMjAwNDgxNTI0M15BMl5BanBnXkFtZTgwNTY4MDI1NzM@._V1_SX300.jpg",
        "Title": "Dark Phoenix",
        "Year": "2019",
        "imdbID": "tt6565702"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BNzVhMjcxYjYtOTVhOS00MzQ1LWFiNTAtZmY2ZmJjNjIxMjllXkEyXkFqcGdeQXVyNTc5OTMwOTQ@._V1_SX300.jpg",
        "Title": "Alita: Battle Angel",
        "Year": "2019",
        "imdbID": "tt0437086"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BNGVjNWI4ZGUtNzE0MS00YTJmLWE0ZDctN2ZiYTk2YmI3NTYyXkEyXkFqcGdeQXVyMTkxNjUyNQ@@._V1_SX300.jpg",
        "Title": "Joker",
        "Year": "2019",
        "imdbID": "tt7286456"
    }, {
        "Poster": "https://m.media-amazon.com/images/M/MV5BMTYzMDM4NzkxOV5BMl5BanBnXkFtZTgwNzM1Mzg2NzM@._V1_SX300.jpg",
        "Title": "Toy Story 4",
        "Year": "2019",
        "imdbID": "tt1979376"
    }
]